import _classCallCheck from "D:\\Programming_Projects\\PokemonRevolution\\teammagma\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Programming_Projects\\PokemonRevolution\\teammagma\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import endpoints from './endpoints.json';
import rootEndpoints from './rootEndpoints.json';
import { loadResource } from './getter.js';
import { values } from './default.js';
import { configurator } from './configurator.js';
export var Pokedex =
/*#__PURE__*/
function () {
  function Pokedex(config) {
    var _this = this;

    _classCallCheck(this, Pokedex);

    configurator.setPokedexConfiguration(config);
    configurator.setRootEndpointConfiguration(config); // add to Pokedex.prototype all our endpoint functions

    endpoints.forEach(function (endpoint) {
      _this[endpoint[0]] = function (input) {
        if (input) {
          // if the user has submitted a Name or an ID, return the JSON promise
          if (typeof input === 'number' || typeof input === 'string') {
            return loadResource("".concat(values.versionPath).concat(endpoint[1], "/").concat(input, "/"));
          } // if the user has submitted an Array
          // return a new promise which will resolve when all loadResource calls are ended
          else if (typeof input === 'object') {
              return Promise.all(mapResources(endpoint, input));
            }
        }
      };
    });
    rootEndpoints.forEach(function (rootEndpoint) {
      _this[rootEndpoint[0]] = function (config) {
        var limit = values.limit;
        var offset = values.offset;

        if (config) {
          if (config.hasOwnProperty('offset')) {
            offset = config.offset;
          }

          if (config.hasOwnProperty('limit')) {
            limit = config.limit;
          }
        }

        return loadResource("".concat(values.versionPath).concat(rootEndpoint[1], "?limit=").concat(limit, "&offset=").concat(offset));
      };
    });
  }

  _createClass(Pokedex, [{
    key: "resource",
    value: function resource(path) {
      if (typeof path === 'string') {
        return loadResource(path);
      } else if (typeof path === 'object') {
        return Promise.all(path.map(function (p) {
          return loadResource(p);
        }));
      } else {
        return 'String or Array is required';
      }
    }
  }]);

  return Pokedex;
}();
;

function mapResources(endpoint, input) {
  return input.map(function (res) {
    return loadResource("".concat(values.versionPath).concat(endpoint[1], "/").concat(res, "/"));
  });
}